import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
//import { createTemplate } from '../store/slices/templateSlice';
import './TemplateForm.css';

export const TemplateForm = ({ planData = null, onSuccess, onCancel }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    category: '',
    tags: '',
    isPublic: true
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const categories = [
    'спортивное',
    'низкоуглеводное', 
    'кето',
    'вегетарианское',
    'здоровое',
    'похудение',
    'набор массы'
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  
  if (!formData.name.trim()) {
    setError('Введите название шаблона');
    return;
  }

  if (!formData.category) {
    setError('Выберите категорию');
    return;
  }

  setLoading(true);
  setError('');

  try {
    // Подготавливаем данные формы
    const templateData = {
      name: formData.name.trim(),
      description: formData.description.trim(),
      category: formData.category,
      tags: formData.tags
        .split(',')
        .map(tag => tag.trim())
        .filter(tag => tag),
      isPublic: formData.isPublic
    };

    // Если создаем из плана, отправляем запрос с sourcePlan
   /* if (planData) {
      // Отправляем специальный запрос для создания из плана
      const result = await dispatch(createTemplateFromPlan({
        planId: planData._id,
        templateData
      })).unwrap();
      
      if (onSuccess) {
        onSuccess(result.data);
      }
    } else {
      // Если создаем шаблон с нуля
     // const result = await dispatch(createTemplate(templateData)).unwrap();
      
      if (onSuccess) {
        onSuccess(result.data);
      }
    }*/
    
    // Сброс формы
    setFormData({
      name: '',
      description: '',
      category: '',
      tags: '',
      isPublic: true
    }); 

  } catch (err) {
    setError(err.message || 'Ошибка при создании шаблона');
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="template-form-container">
      <div className="template-form-header">
        <h3>{planData ? 'Сохранить план как шаблон' : 'Создать новый шаблон'}</h3>
        {planData && (
          <div className="plan-info-badge">
            Основывается на плане от {new Date(planData.date).toLocaleDateString()}
          </div>
        )}
      </div>

      <form onSubmit={handleSubmit} className="template-form">
        {error && (
          <div className="form-error">
            <span className="error-icon">⚠️</span>
            {error}
          </div>
        )}

        <div className="form-group">
          <label htmlFor="name" className="form-label">
            Название шаблона *
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Например: Спортивное питание на 3000 ккал"
            className="form-input"
            maxLength={100}
            disabled={loading}
          />
          <div className="input-hint">
            Максимум 100 символов. Осталось: {100 - formData.name.length}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="description" className="form-label">
            Описание
          </label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Опишите особенности этого шаблона питания..."
            className="form-textarea"
            rows={3}
            maxLength={500}
            disabled={loading}
          />
          <div className="input-hint">
            Максимум 500 символов. Осталось: {500 - formData.description.length}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="category" className="form-label">
            Категория *
          </label>
          <select
            id="category"
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="form-select"
            disabled={loading}
          >
            <option value="">Выберите категорию</option>
            {categories.map(category => (
              <option key={category} value={category}>
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="tags" className="form-label">
            Теги
          </label>
          <input
            type="text"
            id="tags"
            name="tags"
            value={formData.tags}
            onChange={handleChange}
            placeholder="белок, спорт, завтрак, ужин"
            className="form-input"
            disabled={loading}
          />
          <div className="input-hint">
            Введите теги через запятую
          </div>
        </div>

        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="isPublic"
              checked={formData.isPublic}
              onChange={handleChange}
              disabled={loading}
              className="checkbox-input"
            />
            <span className="checkbox-custom"></span>
            <span className="checkbox-text">Сделать шаблон публичным</span>
          </label>
          <div className="input-hint">
            Публичные шаблоны видны другим пользователям
          </div>
        </div>

        {planData && (
          <div className="plan-preview">
            <h4>Информация о плане:</h4>
            <div className="plan-stats">
              <div className="stat-item">
                <span className="stat-label">Калории:</span>
                <span className="stat-value">{planData.nutritionTotals?.calories || 0}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Блюд:</span>
                <span className="stat-value">
                  {(planData.breakfast?.length || 0) + 
                   (planData.lunch?.length || 0) + 
                   (planData.dinner?.length || 0)}
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="form-actions">
          <button
            type="button"
            onClick={onCancel}
            className="btn btn-secondary"
            disabled={loading}
          >
            Отмена
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Сохранение...
              </>
            ) : (
              'Сохранить шаблон'
            )}
          </button>
        </div>
      </form>
    </div>
  );
};